'use strict';

var BOSHConnection = require('../transports/bosh');


module.exports = function (client) {

    client.transports.bosh = BOSHConnection;
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/bosh.js
// module id = 549
// module chunks = 2